import { api } from '@/core/api/'

const apiUrl = 'api/edenexit'

export default {
  getExitByYear(params) {
    return api.get(`${apiUrl}/ExitByYear`, { params: params })
  },
  getAvailableAcademicYears() {
    return api.get(`${apiUrl}/AvailableAcademicYears`)
  },
  getDetail(edenExitId) {
    return api.get(`${apiUrl}/detail?edenExitId=${edenExitId}`)
  },
  submitReport(params) {
    return api.put(`${apiUrl}/submitmaster`, params)
  },
  searchDetail(params) {
    return api.post(`${apiUrl}/searchdetail`, params)
  },
  getFiles(edenMasterId) {
    return api.get(`${apiUrl}/files/${edenMasterId}`)
  },
  deleteFiles(edenMasterId) {
    return api.delete(`${apiUrl}/files/delete/${edenMasterId}`)
  },
  getReportAvailableAcademicYears() {
    return api.get(`${apiUrl}/reportavailableacademicyears`)
  },
  createEdenExitReport(academicYearId) {
    return api.post(`${apiUrl}/createedenexitreport/${academicYearId}`)
  },
  updateEdenExitReport(id) {
    return api.put(`${apiUrl}/updateedenexitreport/${id}`)
  },
  executealert(edenExitId, edenDataValidationErrorId) {
    return api.post(
      `${apiUrl}/executealert/${edenExitId}/${edenDataValidationErrorId}`
    )
  },
  amendReport(params) {
    return api.post(`${apiUrl}/amendReport`, params)
  },
  generateFiles(id) {
    return api.post(`${apiUrl}/generateexitfiles/${id}`)
  },
  getEdenFile(id) {
    return api.get(`${apiUrl}/file/${id}`)
  },
  publishPublicPortalData(edenMasterId) {
    return api.post(`${apiUrl}/publishpublicportaldata/${edenMasterId}`)
  },
}
